import React, { Component } from 'react';
import { Result, Icon, WhiteSpace } from 'antd-mobile';
import * as services from '../projects/services';
import { CommonlyHead } from '../common/headnav';
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
export default class QuanrenResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resultData: [],
            OrderNo: this.props.match.params.orderId,
            errornum: 0,
            errormessage: '',
            isTrue: false,
        }
    }
    componentDidMount() {
        services.GetOrderPayment(this.state.OrderNo, '').then(data => {
            if (data.status === 0) {
                if (data.result.length > 0) {
                    this.setState({ resultData: data.result });
                } else {
                    this.setState({ errornum: 1, errormessage: '付款失败' });
                }
            } else {
                this.setState({ errornum: 1, errormessage: data.message });
            }
        });

        services.GetIsappointment(this.state.OrderNo, '').then(data => {
            if (data.status === 0) {
                this.setState({ isTrue: data.result });
            }
        });

    }
    render() {
        const { resultData, isTrue, errornum } = this.state;
        return <div className="quanrenResult" style={{ minHeight: document.documentElement.clientHeight }}>
            <CommonlyHead barname={'支付结果页'} />
            {
                <div key={'cindex'} >
                {errornum !== 1 && resultData.length > 0 ?
                    <Result
                        img={<Icon type="check-circle" className="spe" style={{ fill: '#32a128', fontSize: '26px' }} />}
                        title="付款成功"
                    />
                    : ''
                }  
                 {
                this.state.errornum !== 1 ? '' :
                    <Result
                        img={<Icon type="cross-circle-o" className="spe" style={{ fill: '#F13642' }} />}
                        title={this.state.errormessage}
                    />
            }            
                {resultData.map((data, index) =>
                    (
                        <table key={index} >
                            <tbody>
                                <tr><td>订单号：</td><td> {data.orderid}</td></tr>
                                <tr><td>付款方式：</td><td> {data.paymentname}</td></tr>
                                <tr><td>交易号：</td><td> {data.paymenttradeid}</td></tr>
                                <tr><td>付款金额(元)：</td><td className="color"> ￥{data.paymoney}</td></tr>
                                <tr><td>付款状态：</td><td> {data.paystatus === 2 ? '付款成功' : '付款失败'}</td></tr>
                                <tr>
                                    <td>合计:</td>
                                    <td>{data.paycontent}</td>
                                </tr>
                            </tbody>
                        </table>
                    ))}
                <WhiteSpace />
            </div>
            }
           
            <div className="buts">
                {
                    !!isTrue ?
                        <button className="but" onClick={() => {
                            history.push('/members/orderment/0');
                            history.go();
                        }}>去预约</button>
                        : <button className="but" onClick={() => {
                            history.push('/members/orderment/1');
                            history.go();
                        }}>去体检</button>
                }
                <button className="but" onClick={() => {
                    history.push('/members/order');
                    history.go();
                }}>我的订单</button>
            </div>

        </div>;
    }
}